import axios from '@/plugins/axios'

export default {
    getPrefetchSettings() {
        return axios({
            url: '/prefetch-settings/detail',
            method: 'get'
        })
    },
    savePrefetchSettings(data){
        return axios({
            url: '/prefetch-settings/save',
            method: 'post',
            data
        })
    },
    disconnectGA() {
        return axios({
            url: '/prefetch-settings/deactive-ga',
            method: 'post'
        })
    }
}
